<div class="flex" style="margin-top: 15px;" *ngIf="measurementTypes && measurementTypes.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="measurementTypes"
        [totalRecords]="totalMeasurementTypes"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onPage)="onPageChange($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'attribute.sensor' | transloco}}</th>
            <th>{{'attribute.unit' | transloco}}</th>
            <th>{{'attribute.dataType' | transloco}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-type>
          <tr *ngIf="!loadingMeasurementTypes">
            <td>
              <span class="p-column-title bold">{{'attribute.sensor' | transloco}}</span>
              {{type.sensor}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.unit' | transloco}}</span>
              {{type.unit}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.dataType' | transloco}}</span>
              {{type.dataType}}
            </td>
          </tr>
          <tr *ngIf="loadingMeasurementTypes">
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalMeasurementTypes == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalMeasurementTypes > 0">
            Showing {{first+1}}
            to {{(first+rows) >= totalMeasurementTypes ? totalMeasurementTypes : (first+rows)}}
            of {{totalMeasurementTypes}} {{totalMeasurementTypes > 1 ? 'entries':'entry'}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="measurementTypes && measurementTypes.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.sensorTypes' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!measurementTypes">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
